module.exports = __webpack_public_path__ + "media/images/pages/isaac/meta-image-296ca86c4b88f968813d5b458795acc8.jpg";